import { Box, ButtonBase, Stack, Typography } from "@mui/material"
import { useTasks } from "../contexts/task"
import AppModal from "../layouts/layout-mobile/AppModal"
import FlexRowAlign from "../components/flexbox/FlexRowAlign"
import Iconify from "../components/Iconify"
import { useCallback, useEffect, useState } from "react"
import FlexBetween from "../components/flexbox/FlexBetween"
import useAxios from "../hooks/useAxios"
import $ from 'jquery'
import { useQueryClient } from "@tanstack/react-query"

export const ProcessingTask = () => {
    const [isActive, setIsActive] = useState(false)
    const [open, setOpen] = useState(false)
    const { callApi } = useAxios()
    const queryClient = useQueryClient()

    const handleListener = useCallback(async () => {
        const data = await callApi('get', '/ws/ws-payload')
        if (!Boolean(data)) return
        const { payload, event } = data
        const container = document.getElementById('task-content');
        let items = []
        switch (event) {
            case 'MODE': {
                items = container?.querySelectorAll('.item.MODE');
                queryClient.invalidateQueries({ queryKey: ['UserData'] })
                break
            }
            case 'INCREASE-POWER': {
                items = container?.querySelectorAll('#INCREASE_POWER');
                queryClient.invalidateQueries({ queryKey: ['UserBalance'] })
                break
            }
            case 'RESTORE-POWER': {
                items = container?.querySelectorAll('#RESTORE_POWER');
                queryClient.invalidateQueries({ queryKey: ['UserBalance'] })
                break
            }
        }
        items.forEach(e => $(e).removeClass('active'))
        setOpen(false)
    })

    useEffect(() => {
        const interval = setInterval(() => {
            const container = document.getElementById('task-content');
            const items = container?.querySelectorAll('.item.active');
            if (items?.length > 0) {
                setIsActive(true)
                handleListener()
            } else {
                setIsActive(false)
            }
        }, 5000);
        return () => {
            clearInterval(interval)
        }
    }, [handleListener])

    return <>
        <ButtonBase disabled={!isActive} onClick={() => setOpen(true)}>
            {
                isActive ? <Stack alignItems={'center'} justifyContent={'center'} sx={{ position: 'relative', color: '#8AEB5D' }}>
                    <Iconify icon={'radix-icons:dot-filled'} size={20} sx={{ position: 'absolute' }} />
                    <Iconify icon={'svg-spinners:pulse'} size={20} />
                </Stack> : ''
            }
            <Typography sx={{ opacity: isActive ? 1 : 0.3 }}>Transactions</Typography>
        </ButtonBase>
        <AppModal keepMounted={true} open={open} sx={{ zIndex: 95 }} onClose={() => setOpen(false)} title={"Transactions"}>
            <Stack spacing={2} id="task-content">
                {
                    tasks.map((item, index) => <TaskItem key={index} data={item} />)
                }
            </Stack>
        </AppModal>
    </>
}

const TaskItem = ({ data }) => {
    return <Stack className={`item ${data?.id?.includes('_MODE') ? 'MODE' : ''}`} id={data?.id} sx={{ display: 'none', "&.active": { display: "initial" } }}>
        <FlexBetween gap={1} alignItems='flex-end' justifyContent="flex-start">
            <Typography variant="h6">{data?.title}</Typography>
            <Iconify icon={'svg-spinners:bars-fade'} size={17} sx={{ color: '#8AEB5D', marginBottom: '1px' }} />
        </FlexBetween>
        <Typography>## {data?.description}</Typography>
    </Stack>
}

const tasks = [
    {
        id: 'INCREASE_POWER',
        title: 'Increase power capacity...',
        description: 'Your power will increase soon.'
    },
    {
        id: 'RESTORE_POWER',
        title: 'Restore your power...',
        description: 'Your power will fully soon.'
    },
    {
        id: 'ACTIVE_SUPER_MODE',
        title: 'Active super mode...',
        description: 'Your mode will upgrade soon.'
    },
    {
        id: 'ACTIVE_DELUXE_MODE',
        title: 'Active deluxe mode...',
        description: 'Your mode will upgrade soon.'
    },
    {
        id: 'ACTIVE_PREMIUM_MODE',
        title: 'Active premium mode...',
        description: 'Your mode will upgrade soon.'
    },
    {
        id: 'ACTIVE_ULTIMATE_MODE',
        title: 'Active ultimate mode...',
        description: 'Your mode will upgrade soon.'
    }
]